import Calendar from "../../components/calendar";
import { Container, Typography } from "@mui/material";

export default function TaskCalendarView() {
    return (
        <Container maxWidth={false}>
            <Calendar />
        </Container>
    )
}